import { LocaleIdentifier } from '@repo/markets/types'
import { NavigationQueryResult } from '@repo/sanity/types'
import { Accordion, AccordionContent, AccordionItem, AccordionLinkTrigger, AccordionTrigger } from '@repo/ui/components/accordion'
import { cn } from '@repo/ui/lib/utils'
import { LinkProps } from 'next/dist/client/link'
import { CSSProperties, FunctionComponent } from 'react'
import LinkResolver from '../../links/LinkResolver'

interface Props {
  locale: LocaleIdentifier
  links: NonNullable<NavigationQueryResult>['primaryLinks'] | NonNullable<NavigationQueryResult>['secondaryLinks'] | NonNullable<NavigationQueryResult>['supportLinks']
  level?: number
  onNavigate?: LinkProps['onNavigate']
}

const AccordionLinkLoop: FunctionComponent<Props> = ({ locale, links, level = 0, onNavigate }) => {
  return (
    <>
      {links?.flatMap((link) => {
        if (!link?.label) {
          return []
        }

        if (link?._type === 'linkSet') {
          const subLinks = link?.links || []

          if (subLinks.length === 0) {
            return []
          }

          return (
            <AccordionItem key={link._key} value={`shop-${link._key}`} variant='lightStatic' rounded={false} style={{ '--level': level || 0 } as CSSProperties}>
              <AccordionTrigger className={cn(level > 0 && 'pl-[calc(var(--level)_*_1.5rem)]')}>{link?.label}</AccordionTrigger>
              <AccordionContent className='p-0'>
                <Accordion type='single' collapsible={true} className='w-full'>
                  {subLinks.map((subLink) => {
                    return (
                      <AccordionItem key={subLink._key} value={`shop-${link._key}`} variant='lightStatic' rounded={false}>
                        <AccordionLinkTrigger className='pl-[calc(var(--level)_*_1.5rem)]' style={{ '--level': (level || 0) + 1 } as CSSProperties}>
                          <LinkResolver link={subLink} locale={locale} onNavigate={onNavigate}>
                            {subLink?.label}
                          </LinkResolver>
                        </AccordionLinkTrigger>
                      </AccordionItem>
                    )
                  })}
                </Accordion>
              </AccordionContent>
            </AccordionItem>
          )
        }

        return (
          <AccordionItem key={link._key} value={`shop-${link._key}`} variant='lightStatic' rounded={false} style={{ '--level': level || 0 } as CSSProperties}>
            <AccordionLinkTrigger className={cn(level > 0 && 'pl-[calc(var(--level)_*_1.5rem)]')}>
              <LinkResolver link={link} locale={locale} onNavigate={onNavigate}>
                {link?.label}
              </LinkResolver>
            </AccordionLinkTrigger>
          </AccordionItem>
        )
      })}
    </>
  )
}

export default AccordionLinkLoop
